import MUIMenuItem from "@mui/material/MenuItem"
import React from "react"

export type MenuItemProps =
  | ({ new?: false } & React.ComponentProps<typeof MUIMenuItem>)
  | ({ new: true } & unknown)

export const MenuItem: React.FC<MenuItemProps> = (props) =>
  props.new ? null : <MUIMenuItem {...props} />

export default MenuItem
